<div class="wrap">
    <app-offer-details [offerSub]="data.offerSub"></app-offer-details>
</div>